import { put, call, takeEvery } from 'redux-saga/effects';
import {
  APP_CONFIGURATION_REQUEST,
  CREATE_APP_CONFIGURATION_REQUEST,
  UPDATE_APP_CONFIGURATION_REQUEST,
} from './actionTypes';
import {
  appConfigurationSuccess,
  appConfigurationFailure,
  createAppConfigurationSuccess,
  createAppConfigurationFailure,
  updateAppConfigurationSuccess,
  updateAppConfigurationFailure,
} from './actions';
import AppConfigurationService from '../../services/AppConfigurationService';

export function* getAppConfigurationTask(action) {
  try {
    const appId = action.payload;
    const appConfiguration = yield call(
      AppConfigurationService.getAppConfiguration,
      appId,
    );
    yield put(appConfigurationSuccess(appConfiguration));
  } catch (error) {
    yield put(appConfigurationFailure(error));
  }
}

export function* createAppConfigurationTask(action) {
  try {
    const params = action.payload;
    const appConfiguration = yield call(
      AppConfigurationService.createAppConfiguration,
      params,
    );
    yield put(createAppConfigurationSuccess(appConfiguration));
  } catch (error) {
    yield put(createAppConfigurationFailure(error));
  }
}

export function* updateAppConfigurationTask(action) {
  try {
    const params = action.payload;
    const appConfiguration = yield call(
      AppConfigurationService.updateAppConfiguration,
      params,
    );
    yield put(updateAppConfigurationSuccess(appConfiguration));
  } catch (error) {
    yield put(updateAppConfigurationFailure(error));
  }
}

export function* appConfigurationsSaga() {
  yield takeEvery(APP_CONFIGURATION_REQUEST, getAppConfigurationTask);
  yield takeEvery(CREATE_APP_CONFIGURATION_REQUEST, createAppConfigurationTask);
  yield takeEvery(UPDATE_APP_CONFIGURATION_REQUEST, updateAppConfigurationTask);
}
